export const isAbortError = (error: Error): boolean =>
  error.name === 'AbortError'
